import $ from "jquery";
import Template from "./SectionsMapMenu.ejs";
import makeTemplateFunc from "lodash/template";

const TemplateFunc = makeTemplateFunc(Template);

class SectionsMapMenu {

    render($container, response) {
        $container.html(TemplateFunc({response}));
        this.fixSize();
    }

    fixSize() {
        const $container = $('.js-section-inner');
        $container.removeAttr('style');
        const containerWidth = $container.width();
        const containerHeight = $container.height();
        const $parent = $container.parent();
        const parentWidth = $parent.width();
        const parentHeight = $parent.height();

        const diffWidth = parentWidth - containerWidth;
        const diffHeight = parentHeight - containerHeight;

        if (diffWidth > 0 && diffWidth > diffHeight) {
            $container.width(containerWidth + diffWidth);
            $container.height(containerHeight + diffWidth);
        }

        if (diffHeight > 0 && diffHeight > diffWidth) {
            $container.width(containerWidth + diffHeight);
            $container.height(containerHeight + diffHeight);
        }
    }
}

export default new SectionsMapMenu();


// WEBPACK FOOTER //
// ./js/components/SectionsMapMenu/SectionsMapMenu.js